(function () {
  const SELECTOR = "[data-cf-coming-soon-countdown]";

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function updateItem(element) {
    const openAtTs = Number(element.getAttribute("data-open-at-ts") || 0);

    if (!openAtTs) return;

    const nowTs = Math.floor(Date.now() / 1000);
    const diff = openAtTs - nowTs;

    if (diff <= 0) {
      element.textContent = "開始しました";
      return;
    }

    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    const daysEl = element.querySelector('[data-unit="days"]');
    const hoursEl = element.querySelector('[data-unit="hours"]');
    const minutesEl = element.querySelector('[data-unit="minutes"]');
    const secondsEl = element.querySelector('[data-unit="seconds"]');

    if (daysEl) daysEl.textContent = days;
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  function init() {
    const items = Array.from(document.querySelectorAll(SELECTOR));
    if (!items.length) return;

    function tick() {
      items.forEach(updateItem);
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();